var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('Header'),_c('div',{staticClass:"layout-wrapper"},[_c('div',{staticClass:"layout-menu"},[_c('left-bar')],1),_c('div',{staticClass:"layout-content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }